<div
	class="promptuary-pendencies"
	*ngIf="
		isPendenciesLoaded &&
		(pendencies?.past?.length > 0 || pendencies?.today?.length > 0)
	"
>
	<div
		class="promptuary-pendencies__header"
		[ngClass]="{
			'promptuary-pendencies__header--late': pendencies?.past?.length > 0
		}"
	>
		<div class="zk-flex zk-gap-2 zk-items-center">
			<span class="freud-icon freud-icon-report"></span>
			<span class="promptuary-pendencies__title">{{
				'PROMPTUARY.PENDENCIES' | translate
			}}</span>
		</div>
	</div>
	<div class="promptuary-pendencies__body">
		<div class="today-pendencies" *ngIf="pendencies.today?.length > 0">
			<div class="pendency__tab" (click)="toogleTab('today')">
				<span
					class="freud-icon"
					[ngClass]="{
						'freud-icon-chevron-down': isTodayPendenciesOpen,
						'freud-icon-chevron-right': !isTodayPendenciesOpen
					}"
				></span>
				<span class="promptuary-pendencies__subtitle">{{
					'PROMPTUARY.TODAY' | translate
				}}</span>
			</div>
			<div *ngIf="isTodayPendenciesOpen">
				<div *ngFor="let pendency of pendencies?.today" class="pendency__item">
					<div class="zk-flex zk-flex-row zk-ml-5 zk-items-center">
						<appointment-type-badge [subscriptionType]="pendency?.isB2B ? 'corporate_subscription' : null" [iconOnly]="true"></appointment-type-badge>
					</div>
					<div class="zk-flex zk-flex-col zk-ml-4 zk-w-full">
						<span class="pendency__name">{{ pendency.username }}</span>
						<span class="pendency__date">{{ formatDate(pendency.date) }}</span>
					</div>
					<div class="zk-flex zk-items-end zk-justify-end zk-w-full">
						<freud-button
							color="ghost"
							class="zk-mr-1 zk-ml-2"
							(click)="openSidebar(pendency.profileId, pendency.appointmentId)"
							>{{ 'PROMPTUARY.REGISTER' | translate }}</freud-button
						>
					</div>
				</div>
			</div>
		</div>
		<div class="late-pendecies" *ngIf="pendencies?.past?.length > 0">
			<div class="pendency__tab" (click)="toogleTab('late')">
				<span
					class="freud-icon"
					[ngClass]="{
						'freud-icon-chevron-down': isLatePendenciesOpen,
						'freud-icon-chevron-right': !isLatePendenciesOpen
					}"
				></span>
				<span class="promptuary-pendencies__subtitle">{{
					'PROMPTUARY.LATE' | translate
				}}</span>
			</div>
			<div *ngIf="isLatePendenciesOpen">
				<div
					*ngFor="let pendency of pendencies?.past; let i = index"
					class="pendency__item"
					[id]="'pendency__item-' + i"
				>
					<div *ngIf="i === 3" class="overlay"></div>
					<div class="zk-flex zk-flex-row zk-ml-4 zk-items-center">
						<appointment-type-badge [subscriptionType]="pendency?.isB2B ? 'corporate_subscription' : null" [iconOnly]="true"></appointment-type-badge>
					</div>
					<div class="zk-flex zk-flex-col zk-ml-3 zk-w-full">
							<span class="pendency__name">{{ pendency.username }}</span>
							<span class="pendency__date">{{ formatDate(pendency.date) }}</span>
					</div>
					<div class="zk-flex zk-items-end zk-justify-end zk-w-full zk-items-center">
						<freud-button
							*ngIf="i !== 3"
							class="zk-mr-1 zk-ml-2"
							color="ghost"
							(click)="openSidebar(pendency.profileId, pendency.appointmentId)"
							>{{ 'PROMPTUARY.REGISTER' | translate }}</freud-button
						>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="promptuary-pendencies__footer">
		<div class="promptuary-pendencies__know-more" *ngIf="isKnowMoreOpen">
			<div class="pendency__link">
				<span class="freud-icon freud-icon-info-circle"></span>
				<a
					rel="noopener"
					href="https://hs-info.zenklub.com/faq/por-que-preencher-o-prontu%C3%A1rio"
					target="_blank"
					>{{ 'PROMPTUARY.WHY_FILL' | translate }}</a
				>
			</div>
			<span
				class="freud-icon freud-icon-times"
				(click)="closeKnowMore()"
			></span>
		</div>
	</div>
</div>

<freud-card
	*ngIf="
		isPendenciesLoaded &&
		pendencies?.past?.length === 0 &&
		pendencies?.today?.length === 0
	"
>
	<div class="no-pendencies">
		<div class="award__wrapper">
			<span class="freud-icon freud-icon-award"></span>
			<ng-lottie
				height="180px"
				[options]="{ loop: false, path: '/assets/lottie/confeti.json' }"
			></ng-lottie>
		</div>
		<div class="award__texts">
			<span class="no-pendencies__title">{{
				'PROMPTUARY.CONGRATS' | translate
			}}</span>
			<span class="no-pendencies__subtitle">{{
				'PROMPTUARY.REGISTER_ALL' | translate
			}}</span>
		</div>
	</div>
</freud-card>
